/* eslint-disable angular/no-private-call */
import angular from 'angular';

const routesAuthorization = (
  $location,
  $rootScope,
  appRouting,
) => {
  'ngInject';

  const removeEvent = $rootScope.$on('$routeChangeStart', (event, next) => {
    if (angular.isDefined(next) && angular.isDefined(next.$$route)) {
      const validation = appRouting.validate(next.$$route);
      if (validation.denied) {
        event.preventDefault();
        $location.url(validation.redirectTo);
      }
    }
  });

  $rootScope.$on('$destroy', () => {
    removeEvent();
  });
};

export default routesAuthorization;
